import React from "react";
import { Zap, Mail, PartyPopper } from "lucide-react";
import Card from "../components/Card/Card";

// Steps data: each object represents one step in the process
const steps = [
    {
        // Step 1: Choose recognition type
        Icon: <Zap className="w-10 h-10 md:w-20 md:h-20 text-yellow-500" />,
        title: "Choose Recognition Type",
        description: "Choose from shout-outs or power-ups categories.",
    },
    {
        // Step 2: Write your message
        Icon: <Mail className="w-10 h-10 md:w-20 md:h-20 text-green-500" />,
        title: "Write Your Message",
        description:
            "Craft a meaningful message that highlights specific achievements and impact.",
    },
    {
        // Step 3: Share and celebrate
        Icon: <PartyPopper className="w-10 h-10 md:w-20 md:h-20 text-pink-500" />,
        title: "Share & Celebrate",
        description:
            "Your recognition appears on digital displays and gets shared with the team.",
    },
];

// Steps Section Component
const StepsSection: React.FC = () => {
    return (
        <section className="py-10 md:py-20 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Section Heading */}
                <h2 className="text-2xl md:text-3xl font-semibold text-blue-900 mb-3">
                    How PowerUp Works
                </h2>

                {/* Section Subtext */}
                <p className="text-sm md:text-base text-gray-600 mb-8 md:mb-12 max-w-xl mx-auto">
                    Simple, quick, and meaningful recognition in just three steps.
                </p>

                {/* Steps Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8">
                    {steps.map((step, index) => (
                        <Card
                            key={index}               // unique key for React list rendering
                            title={step.title}        // Card title (step name)
                            description={step.description} // Card description (details)
                            Icon={step.Icon}          // Step icon (Zap, Mail, PartyPopper)
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StepsSection;
